import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import NavBar from "../../Components/NavBar";
import IMG_LEFT_TOP from "../../Assests/images/about-us-image-1.png"
import IMG_CENTER_TOP from "../../Assests/images/about-us-image-2.png"
import IMG_RIGHT_TOP from "../../Assests/images/about-us-image-3.png"
import IMG_MISSION from "../../Assests/images/our-mission.png"
import IMG_VISION from "../../Assests/images/our-vision.png"
import Footer from '../../Components/Footer';
const AboutUs = () => {
  const theme = useTheme();
  const isMdDown = useMediaQuery(theme.breakpoints.down('md'));
  const topImages = [
    { src: IMG_LEFT_TOP, alt: 'Team collaboration' },
    { src: IMG_CENTER_TOP, alt: 'Product preview' },
    { src: IMG_RIGHT_TOP, alt: 'Customer using phone' },
  ];

  return (
    <>
      <NavBar textColor="#000000" logoTextColor="#000000" />
      <Box sx={{ pt: { xs: 10, md: 12 } }}>
        {/* Page header breadcrumb */}
        <Container maxWidth="100%">
          <Typography
            variant="body2"
            sx={{
              textAlign: 'center',
              color: 'text.secondary',
              mb: 1,
              pt: { xs: 8, md: 15 },
              fontSize: "20px",
              fontWeight: 400,
              color: "#007BFF",
            }}
          >
            About us
          </Typography>

          {/* Hero title */}
          <Typography
            variant="h2"
            sx={{
              textAlign: 'center',
              fontWeight: 600,
              fontSize: { xs: '1.5rem', sm: '1.9rem', md: '2.9rem' },
              px: { xs: 2, sm: 0 },
              lineHeight: 1.2,
              mb: 1.5,
            }}
          >
            India’s First Ultra-Lowest
            <br />
            Cost Payment Gateway
          </Typography>

          <Typography
            sx={{
              textAlign: 'center',
              color: 'text.secondary',
              maxWidth: { xs: '100%', sm: 760 },
              mx: 'auto',
              mb: { xs: 4, md: 5 },
              color: "#B2B2B2",
              px: { xs: 2, sm: 3 },
              fontSize: { xs: '0.9375rem', sm: '1rem' }
            }}
          >
            Experience seamless, secure, and affordable digital transactions with Zutopay—designed to
            empower businesses across India with the lowest gateway charges in the market.
          </Typography>

          {/* Top images layout */}
          <Grid container spacing={{ xs: 2, md: 3 }} sx={{ 
            mb: { xs: 6, md: 10 }, 
            px: { xs: 2, sm: 3, md: 5 },
            justifyContent: 'center'
          }}>
            {topImages.map((image, index) => (
              <Grid item xs={12} sm={6} md={4} key={index} sx={{ 
                width: { xs: '100%', sm: '48%', md: '31.33%' },
                mb: { xs: index < 2 ? 3 : 0, sm: 0 }
              }}>
                <Box
                  sx={{
                    position: 'relative',
                    width: '100%',
                    height: { xs: 200, sm: 240, md: 600 },
                    borderRadius: 2,
                    overflow: 'hidden',
                    boxShadow: '0 10px 30px rgba(0,0,0,0.10)',
                    mt: index === 1 ? { xs: 0, md: 12 } : 0,
                  }}
                >
                  <Box
                    component="img"
                    src={image.src}
                    alt={image.alt}
                    sx={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                    }}
                  />
                  {/* Linear gradient overlay from 0% to 100% opacity */}
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: 'linear-gradient(180deg, rgba(143, 143, 143, 0) 0%, rgba(143, 143, 143, 1) 100%)',
                      pointerEvents: 'none',
                    }}
                  />
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>

        {/* About section */}
        <Container maxWidth="lg" sx={{ 
          mb: { xs: 6, md: 10 },
          px: { xs: 2, sm: 3 }
        }}>
          <Typography
            variant="h4"
            sx={{ 
              textAlign: 'center', 
              fontWeight: 700, 
              mb: 2,
              fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2.125rem' },
              px: { xs: 2, sm: 0 }
            }}
          >
            About <Typography component="span" sx={{ fontWeight: 500, fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif", fontSize: '2rem', fontStyle: "italic" }}>zutopay</Typography>
          </Typography>

          <Typography sx={{ 
            color: 'text.secondary', 
            mb: 3, 
            textAlign: 'center',
            fontSize: { xs: '0.9375rem', sm: '1rem' },
            lineHeight: 1.7
          }}>
            Whether you're a startup, freelancer, or growing enterprise, Zutopay offers seamless, secure, and lightning-fast transactions with the lowest gateway charges in the country. Our platform is designed for simplicity, scalability, and transparency—no hidden fees, no complicated setups.
          </Typography>
          <Typography sx={{ 
            color: 'text.secondary', 
            mb: 3, 
            textAlign: 'center',
            fontSize: { xs: '0.9375rem', sm: '1rem' },
            lineHeight: 1.7
          }}>
            With multiple payment options, easy integration, and real-time analytics, Zutopay helps you focus on growth while we handle the payments. We believe digital payments should be accessible, affordable, and effortless—and Zutopay is here to make that vision a reality. Join thousands of merchants who trust Zutopay to power their business transactions every day. Experience the future of payments—fast, flexible, and fair.
          </Typography>
          <Typography sx={{ 
            color: 'text.secondary', 
            mb: 3, 
            textAlign: 'center',
            fontSize: { xs: '0.9375rem', sm: '1rem' },
            lineHeight: 1.7
          }}>
            Our platform supports multiple payment options, including UPI, cards, net banking, and wallets, all with transparent pricing and no hidden fees. With easy integration, real-time tracking, and 24/7 support, Zutopay helps you focus on growing your business while we handle your payments. Whether you're selling online, collecting fees, or running a subscription service, Zutopay gives you the tools to accept payments effortlessly.
          </Typography><Typography sx={{ color: 'text.secondary', textAlign: 'center' }}>
            Join thousands of merchants who trust Zutopay to power their transactions and save more with every payment.
          </Typography>

        </Container>

        {/* Mission section - Image Left, Content Right */}
        <Container maxWidth="100%" sx={{ 
          mb: { xs: 6, md: 10 }, 
          px: { xs: 2, sm: 4, md: 8, lg: 12 }
        }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: 'center',
              gap: 4,
            }}
          >
            {/* Image - Left Side */}
            <Box
              sx={{
                flex: '0 0 auto',
                width: { xs: '100%', md: '48%' },
              }}
            >
              <Box
                sx={{
                  position: 'relative',
                  width: '100%',
                  height: { xs: 220, md: 420 },
                  overflow: 'hidden',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.10)',
                }}
              >
                <Box
                  component="img"
                  src={IMG_MISSION}
                  alt="Our mission"
                  sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
              </Box>
            </Box>

            {/* Content - Right Side */}
            <Box
              sx={{
                flex: '1 1 auto',
                width: { xs: '100%', md: '48%' }, 
                pl: { xs: 0, md: 4 },
                pr: { xs: 0, md: 2 }
              }}
            >
              <Typography variant="h5" sx={{ 
                fontWeight: 500, 
                mb: 2,
                fontSize: { xs: '1.25rem', md: '1.5rem' }
              }}>
                Our Mission
              </Typography>
              <Typography sx={{ 
                color: 'text.secondary', 
                color: "black",
                fontSize: { xs: '0.9375rem', sm: '1rem' },
                lineHeight: 1.7
              }}>
                At Zutopay, our mission is to simplify digital payments for every Indian business. We
                aim to deliver ultra-low transaction fees without compromising speed, security, or
                reliability. By offering multiple payment options and easy integration, we help
                merchants grow faster and operate smarter.
                Our goal is to make digital commerce accessible to startups, freelancers, and
                enterprises alike. We believe in transparency, affordability, and innovation—because
                every business deserves better margins.
              </Typography>
            </Box>
          </Box>
        </Container>

        {/* Vision section - Content Left, Image Right */}
        <Container maxWidth="100%" sx={{ mb: { xs: 8, md: 12 }, px: { xs: 8, md: 12 } }}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column-reverse', md: 'row' },
              alignItems: 'center',
              gap: 4,
            }}
          >
            {/* Content - Left Side */}
            <Box
              sx={{
                flex: '1 1 auto',
                width: { xs: '100%', md: '40%' },
              }}
            >
              <Typography variant="h5" sx={{ 
                fontWeight: 500, 
                mb: 2,
                fontSize: { xs: '1.25rem', md: '1.5rem' }
              }}>
                Our Vision
              </Typography>
              <Typography sx={{ color: 'text.secondary', color: "black", pr: { xs: 8, md: 10 } }}>
                To become India's most trusted and affordable digital payment gateway. We envision a
                future where every business—regardless of size or location—can access seamless,
                secure, and low-cost payment solutions. By driving innovation and removing financial
                barriers, Zutopay aims to empower entrepreneurs and accelerate India's digital economy.
                We believe in building an ecosystem that is inclusive, transparent, and built for
                growth. Our vision is to make digital transactions effortless and accessible for all.
              </Typography>
            </Box>

            {/* Image - Right Side */}
            <Box
              sx={{
                flex: '0 0 auto',
                width: { xs: '100%', md: '48%' },
              }}
            >
              <Box
                sx={{
                  position: 'relative',
                  width: '100%',
                  height: { xs: 220, md: 420 },
                  overflow: 'hidden',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.10)',
                }}
              >
                <Box
                  component="img"
                  src={IMG_VISION}
                  alt="Our vision"
                  sx={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                  }}
                />
                {/* Linear gradient overlay */}
              </Box>
            </Box>
          </Box>
        </Container >
      </Box >
      <Footer
        textColor="#000000"
        logoTextColor="#000000"
        headingColor="#2196F3"
      />
    </>

  );
};

export default AboutUs;